var React = require('react');

function House (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M67 25L38.54 2.38a4.11 4.11 0 00-5.08 0L5 25a4.1 4.1 0 00-1.55 3.21v38.2A4.09 4.09 0 007.5 70.5h57a4.09 4.09 0 004.09-4.09V28.18A4.1 4.1 0 0067 25z","fill":"none","strokeMiterlimit":"10","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M47 70.5V48.77a4.09 4.09 0 00-4.09-4.09H29.07A4.09 4.09 0 0025 48.77V70.5","fill":"none","stroke":"inherit","strokeMiterlimit":"10","strokeWidth":"3","key":1})]);
}

House.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 72 72"};

module.exports = House;

House.default = House;
